import React from 'react'

function AdminChat() {
    return (
        <div>AdminChat</div>
    )
}

export default AdminChat